<script>
    export let tags = [];
    export let key = null;
</script>

<style></style>

{#if tags}
<div>
    {#each tags as tag, i}
    <span>        
        {#if i < tags.length-1}
        {key ? tag[key] : tag}, 
        {:else}
        {key ? tag[key] : tag}
        {/if}
    </span>        
    {/each}
</div>
{/if}